+function($, document) {
	var scope;
	
	var StoreCredit = function(element, options) {
		this.$element = $(element);
		this.$body = $(document.body);
		this.options = options;
		
		this.initialize();
	};
	
	StoreCredit.DEFAULTS = {
	};
	
	StoreCredit.prototype.initialize = function() {
		scope = this;
		
		this.amountEl = this.$element.find('input[name="credit_amount"]');
		
		this.observeApply();
		this.observeCancel();
	};
	
	StoreCredit.prototype.observeApply = function() {
		this.$element.on('click', '.btn-success', function() {
			$.publish('showajaxmask.sn');
			
			var deffered = $.post('/cart/apply_credit', {'credit_amount': scope.amountEl.val()});
			
			deffered.done(function(res) {
				if (res.success) {
					window.location = '/cart/checkout';
				}else {
					$('<p class="alert alert-error">' + res.error + '</p>').insertAfter(scope.$element);
				}
			});
			
			
			deffered.always(function() {
				$.publish('hideajaxmask.sn');
			});
		});
	};
	
	StoreCredit.prototype.observeCancel = function() {
		this.$element.on('click', '.btn-danger', function() {
			$.publish('showajaxmask.sn');
			
			var deffered = $.post('/cart/cancel_credit');
			
			deffered.done(function(res) {
				if (res.success) {
					$('<p class="alert alert-success">' + res.feedback + '</p>').insertAfter(scope.$element);
					
					setTimeout(function() {
						window.location = '/cart/checkout';
					}, 1000);
				}
			});
			
			
			deffered.always(function() {
				$.publish('hideajaxmask.sn');
			});
		});
	};
	
	function Plugin(option) {
		var $this   = $(this),
			data   	= $this.data('sn.StoreCredit'),
			options = $.extend({}, StoreCredit.DEFAULTS, typeof option == 'object' && option);
		  
		if ( ! data) {
			$this.data('sn.StoreCredit', (data = new StoreCredit(this, options)));  
		} 
		  
		if (typeof option == 'string') {
			data[option]();  
		} 
	}

	var old = $.fn.storeCredit;
	
	$.fn.storeCredit = Plugin;
	$.fn.storeCredit.Constructor = StoreCredit;
	
	$.fn.storeCredit.noConflict = function () {
	    $.fn.storeCredit = old;
	    return this;
	};
	
	//data-api
	$(function() {
		$('[data-toggle="store-credit"]').each(function () {
			var $element = $(this);
		  
			Plugin.call($element, $element.data())
		});
	})
}(jQuery, document);